/* global L */
var _ = require('lodash');

module.exports = {
  getIcon: function (options) {

    options = _.extend({
      size: 'm',
      smallIcon: 'icon-core-photos',
      icon: 'icon-photo-map-marker',
      className: '',
      color: '#4E4E4E',
      markerType: 'icon-marker-bg-layer'
    }, options);

    // needs to ALWAYS have the `photoset-photo` className
    if (options.className.indexOf('photoset-photo') === -1) {
      options.className = (options.className && 'photoset-photo ' + options.className) || 'photoset-photo';
    }

    return L.FontMarker.icon(options);
  }
};



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/markercluster/photoset/lib/MarkerUtil.js